import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { useHistory } from '@shared/providers/history-provider';
import { useState } from 'react';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { soldGoodsRoutes } from '../sold-goods-routes';
import { getPackagingReferrerLabel } from '../utils';
import { useSoldPackagingTabs } from './tabs';

export default function SoldPackagingLayout() {
  const navigate = useNavigate();
  const tabs = useSoldPackagingTabs();
  const history = useHistory();
  const [referrer] = useState<string | undefined>(history.previousLocation);
  return (
    <Page name="Packaging" title="Sold Packaging">
      <PageHeader
        name="Packaging"
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Sold goods',
            url: generatePath(soldGoodsRoutes.SOLD_PACKAGING),
          },
          {
            label: 'Packaging',
            url: generatePath(soldGoodsRoutes.SOLD_PACKAGING),
          },
        ]}
        toolbar={
          referrer &&
          (referrer.startsWith('/sold-goods/reports/') ||
            referrer.startsWith('/company-reports/')) ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getPackagingReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
